"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _axios = _interopRequireDefault(require("axios"));
var _resolveImage = _interopRequireDefault(require("../../utils/resolveImage"));
var _imageTeaser = _interopRequireDefault(require("../image-teaser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const generateDummyData = counter => {
  let items = [];
  for (let i = 0; i < counter; i++) {
    items.push({
      id: i,
      link: ""
    });
  }
  return items;
};
const ActivityGrid = () => {
  const {
    REACT_APP_PATH
  } = process.env;
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListActivityFilter.api?lang=").concat(i18n.language);
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["list-activity-filter", i18n.language], () => _axios.default.get(url));
  let items = generateDummyData(6);
  if (status === "success") {
    var _data$data;
    items = data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 || (_data$data = _data$data.groups) === null || _data$data === void 0 ? void 0 : _data$data.items;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, items.map(_ref => {
    let {
      id,
      media,
      title
    } = _ref;
    const image = (0, _lodash.first)(media === null || media === void 0 ? void 0 : media.filter(item => {
      return item === null || item === void 0 ? void 0 : item.subFormats;
    }).map(item => {
      return (0, _lodash.first)((0, _resolveImage.default)(item === null || item === void 0 ? void 0 : item.subFormats, "activity-groups-small"));
    }));
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 6,
      key: id
    }, /*#__PURE__*/_react.default.createElement(_imageTeaser.default, {
      id: id,
      image: image,
      title: title
    }));
  }))));
};
var _default = exports.default = ActivityGrid;